import React, { useRef, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { CiLink } from 'react-icons/ci'
import LinkModal from './LinkModal'
import Config from '../../Config/Config.json'

const BioField = props => {
  // props from parent to this file
  const {
    inputData,
    updateInputData,
    handleActiveChange,
    active,
    modeUrl,
    editData,
    sendtruevalue,
  } = props
  const inputReferencedescriptionEn = useRef()
  const inputReferencedescriptionTe = useRef()
  const [modalOpen, setModalOpen] = useState(false)
  const [currentDescription, setCurrentDescription] = useState('')
  const [isTextSelectedEn, setIsTextSelectedEn] = useState(false)
  const [isTextSelectedTe, setIsTextSelectedTe] = useState(false)
  const [selectedText, setSelectedText] = useState('')
  const [link, setLink] = useState('')

  const handleButtonClick = description => {
    setCurrentDescription(description)
    setModalOpen(true)
  }

  const handleSaveLink = link => {
    const textarea =
      currentDescription === 'Bio'
        ? inputReferencedescriptionEn.current
        : inputReferencedescriptionTe.current

    if (textarea.selectionStart !== undefined && textarea.selectionEnd !== undefined) {
      const start = textarea.selectionStart
      const end = textarea.selectionEnd

      const selectedText =
        currentDescription === 'Bio'
          ? inputData.Bio.substring(start, end)
          : inputData.biote.substring(start, end)
      let updatedText = ''
      // if (selectedText) {
      //   let baseUrl = ''
      //   if (Config.Environment === 'Production') {
      //     // Production environment URL
      //     baseUrl = 'https://telugu.yousay.tv'
      //   } else if (Config.Environment === 'Development') {
      //     // Staging environment URL
      //     baseUrl = 'https://stagingyousay.ktree.org'
      //   } else {
      //     // Default URL for other environments
      //     baseUrl = 'https://stagingyousay.ktree.org'
      //   }

      //   if (link.includes(baseUrl)) {
      //     if (link.includes(`${baseUrl}/en/tfidb/`)) {
      //       updatedText =
      //         currentDescription === 'Bio'
      //           ? `${inputData.Bio.substring(0, start)}<a href='${link.replace(
      //               `${baseUrl}/en/tfidb`,
      //               '',
      //             )}'>${selectedText}</a>${inputData.Bio.substring(end)}`
      //           : `${inputData.biote.substring(0, start)}<a href='${link.replace(
      //               `${baseUrl}/en/tfidb`,
      //               '',
      //             )}'>${selectedText}</a>${inputData.biote.substring(end)}`
      //     } else {
      //       updatedText =
      //         currentDescription === 'Bio'
      //           ? `${inputData.Bio.substring(0, start)}<a href='${link.replace(
      //               `${baseUrl}/tfidb`,
      //               '',
      //             )}'>${selectedText}</a>${inputData.Bio.substring(end)}`
      //           : `${inputData.biote.substring(0, start)}<a href='${link.replace(
      //               `${baseUrl}/tfidb`,
      //               '',
      //             )}'>${selectedText}</a>${inputData.biote.substring(end)}`
      //     }
      //   } else {
      //     updatedText =
      //       currentDescription === 'Bio'
      //         ? `${inputData.Bio.substring(
      //             0,
      //             start,
      //           )}<a href='${link}'>${selectedText}</a>${inputData.Bio.substring(end)}`
      //         : `${inputData.biote.substring(
      //             0,
      //             start,
      //           )}<a href='${link}'>${selectedText}</a>${inputData.biote.substring(end)}`
      //   }
      // }
      if (selectedText) {
        let baseUrl = ''
        if (Config.Environment === 'Production') {
          baseUrl = 'https://telugu.yousay.tv'
        } else if (Config.Environment === 'Development') {
          baseUrl = 'https://stagingyousay.ktree.org'
        } else {
          baseUrl = 'https://stagingyousay.ktree.org'
        }

        if (link.includes(baseUrl)) {
          const path = link.includes(`${baseUrl}/en/tfidb/`)
            ? `${baseUrl}/en/tfidb`
            : `${baseUrl}/tfidb`

          updatedText =
            currentDescription === 'Bio'
              ? `${inputData.Bio.substring(0, start)}<a href='${link.replace(
                  path,
                  '',
                )}'>${selectedText}</a>${inputData.Bio.substring(end)}`
              : `${inputData.biote.substring(0, start)}<a href='${link.replace(
                  path,
                  '',
                )}'>${selectedText}</a>${inputData.biote.substring(end)}`
        } else {
          updatedText =
            currentDescription === 'Bio'
              ? `${inputData.Bio.substring(
                  0,
                  start,
                )}<a href='${link}' target='_blank'>${selectedText}</a>${inputData.Bio.substring(
                  end,
                )}`
              : `${inputData.biote.substring(
                  0,
                  start,
                )}<a href='${link}' target='_blank'>${selectedText}</a>${inputData.biote.substring(
                  end,
                )}`
        }
      }

      //  else {
      //   updatedText = `${
      //     currentDescription === 'description_En'
      //       ? movieAndOttNews
      //       : movieAndOttNewste
      //   }<a href='${link}'></a>`
      // }
      console.log(updatedText, 'updatedText')
      if (updatedText) {
        // (currentDescription === 'description_En' ? setMovieAndOttNews : setMovieAndOttNewste)(
        //   updatedText,
        // )
        if (currentDescription === 'Bio') {
          updateInputData('Bio', updatedText)
          sendtruevalue('Bio', true)
        } else {
          updateInputData('biote', updatedText)
          sendtruevalue('Biote', true)
        }
      }
    }
  }

  const handleSelectionChange = (event, description) => {
    const textarea = event.target
    const { selectionStart } = textarea
    const { selectionEnd } = textarea

    // Update isTextSelected state based on whether text is selected
    // setIsTextSelected(selectionStart !== selectionEnd)
    if (description === 'Bio') {
      setIsTextSelectedEn(selectionStart !== selectionEnd)
    } else {
      setIsTextSelectedTe(selectionStart !== selectionEnd)
    }

    const selectedText = textarea.value.substring(selectionStart, selectionEnd).trim()
    setSelectedText(selectedText)
  }

  const indication = modeUrl
    ? editData.Bio === inputData.Bio || active.Bio === 'TRUE'
      ? { borderColor: 'green' }
      : { borderColor: 'red' }
    : ''
  // function to change English value on change and send to parent
  const bio = event => {
    sendtruevalue('Bio', true)
    updateInputData('Bio', event.target.value)
  }

  // function to change Telugu value on change and send to parent
  const biote = event => {
    sendtruevalue('Biote', true)
    updateInputData('biote', event.target.value)
  }

  return (
    <>
      <div>
        <Row>
          <Col md={6} xs={12}>
            <div>
              <div className='shotbio margintop'>
                <label>
                  short Bio_En:<div className='mandatory'>*</div>
                </label>
                <textarea
                  className='form-control'
                  ref={inputReferencedescriptionEn}
                  value={inputData.Bio}
                  placeholder={`enter short-Bio of ${
                    inputData.contentType === 'movies' ? 'movie' : 'webseries'
                  }`}
                  onChange={event => bio(event)}
                  rows={5}
                  cols={20}
                  style={modeUrl && indication}
                  onSelect={event => handleSelectionChange(event, 'Bio')}
                />
              </div>
              {inputData.Bio.length < 1 && (
                <span className='mandatory1'>Bio should not be empty </span>
              )}
            </div>
            <button
              type='button'
              className='btn btn-primary'
              onClick={() => handleButtonClick('Bio')}
              disabled={!isTextSelectedEn}
            >
              <CiLink />
            </button>
          </Col>
          {inputData.Bio.length > 1 && (
            <Col md={6} xs={12}>
              <div className='shotbio margintop'>
                <label>
                  short Bio_Te:<div className='mandatory'>*</div>
                </label>
                <textarea
                  className='form-control'
                  value={inputData.biote}
                  placeholder='enter short-Bio of movie'
                  ref={inputReferencedescriptionTe}
                  onChange={event => biote(event)}
                  rows={5}
                  cols={20}
                  onSelect={event => handleSelectionChange(event, 'biote')}
                />
              </div>
              {inputData.biote.length < 1 && (
                <span className='mandatory1'>సినిమా బయో ఖాళీగా ఉండకూడదు </span>
              )}
              <button
                type='button'
                className='btn btn-primary'
                onClick={() => handleButtonClick('biote')}
                disabled={!isTextSelectedTe}
              >
                <CiLink />
              </button>
            </Col>
          )}
        </Row>
        {modeUrl ? (
          <div className='tinput'>
            <div
              className='currentlyactive-style'
              style={{ display: 'flex', gap: '10px', position: 'relative' /* , top: '60px'  */ }}
            >
              <input
                id='Bio'
                type='checkbox'
                name='currently active'
                checked={active.Bio === 'TRUE'}
                onChange={event => handleActiveChange(event, 'Bio')}
              />
              <label htmlFor='Bio'>OK</label>
              <br></br>
            </div>
          </div>
        ) : (
          <></>
        )}
        <LinkModal
          isOpen={modalOpen}
          selectedText={selectedText}
          link={link}
          setLink={setLink}
          onClose={() => {
            setModalOpen(false)
            setIsTextSelectedEn(false)
            setIsTextSelectedTe(false)
            setSelectedText('')
            setLink('')
          }}
          onSave={link => {
            handleSaveLink(link)
            setLink('')
            setIsTextSelectedEn(false)
            setIsTextSelectedTe(false)
            setSelectedText('')
          }}
        />
      </div>
    </>
  )
}

export default BioField
